var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("assignTasks.DialogTitle"),
            "close-on-click-modal": false,
            visible: _vm.visible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: { model: _vm.form, size: "small", inline: "" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("assignTasks.SR"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { disabled: "", val: _vm.srInfo.srEmpName },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.srInfo, "srEmpName", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("assignTasks.nowTime"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormDatePicker", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.nowTime,
                      valueformat: "yyyyMMdd",
                      type: "date",
                      placeholder: _vm.$t("assignTasks.nowTime"),
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "nowTime", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("assignTasks.createName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { disabled: "", val: _vm.form.createName },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "createName", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "taskFromType",
                    label: _vm.$t("assignTasks.taskFromType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      disabled: "",
                      val: _vm.form.taskFromType,
                      options: _vm.optConfig.taskFromOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "taskFromType", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "taskType",
                    rules: _vm.rules.validateChoose,
                    label: _vm.$t("assignTasks.taskType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.form.taskType,
                      options: _vm.optConfig.planTypeOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "taskType", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("assignTasks.rtlRtmCategory"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.form.rtlRtmCategory,
                      options: _vm.optConfig.rtmOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "rtlRtmCategory", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("assignTasks.retailerType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.form.retailerType,
                      options: _vm.optConfig.storeCategoryOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "retailerType", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "storeAddress",
                    label: _vm.$t("assignTasks.storeAddress"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormCascader", {
                    attrs: {
                      "target-form": _vm.form,
                      "key-list": [
                        "rtlRegion",
                        "rtlRegionCode",
                        "rtlCity",
                        "rtlCityCode",
                        "rtlDistrict",
                        "rtlDistrictCode",
                      ],
                      "region-props": _vm.regionProps,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "signBoardBidFlag",
                    label: _vm.$t("assignTasks.signBoardBidFlag"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.form.signBoardBidFlag,
                      options: _vm.optConfig.yesnoOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "signBoardBidFlag", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "retailorStoreInfoPk",
                    label: _vm.$t("assignTasks.retailorStore"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "el-input__inner store-select",
                      on: { click: _vm.showStoreModel },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.selectStoreName || "请选择门店") +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "visitPurpose",
                    label: _vm.$t("assignTasks.visitPurpose"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("common.pleaseSelect") },
                      model: {
                        value: _vm.form.visitPurpose,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "visitPurpose", $$v)
                        },
                        expression: "form.visitPurpose",
                      },
                    },
                    _vm._l(
                      _vm.optConfig.visitPurposeOptions,
                      function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.code },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "dueTime",
                    label: _vm.$t("assignTasks.dueTime"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormDatePicker", {
                    attrs: {
                      val: _vm.form.dueTime,
                      valueformat: "yyyy-MM-dd",
                      type: "date",
                      placeholder: _vm.$t("assignTasks.dueTime"),
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "dueTime", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "flexRow",
                  attrs: {
                    prop: "comment",
                    rules: _vm.rules.validateChoose,
                    label: _vm.$t("assignTasks.remark"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-autocomplete", {
                    staticClass: "inline-input",
                    attrs: {
                      "fetch-suggestions": _vm.querySearch,
                      "value-key": "name",
                      placeholder: _vm.$t("common.pleaseInput"),
                    },
                    model: {
                      value: _vm.form.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "comment", $$v)
                      },
                      expression: "form.comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelSubmit } }, [
                _vm._v(_vm._s(_vm.$t("common.cancel"))),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitTask } },
                [_vm._v(_vm._s(_vm.$t("common.send")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("assignTasks.DialogTitle"),
            "close-on-click-modal": false,
            visible: _vm.isShowStoreModel,
            fullscreen: "",
            "before-close": _vm.storeModelClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowStoreModel = $event
            },
          },
        },
        [
          _c(
            "BoxWrap",
            { attrs: { title: _vm.$t("assignTasks.retailorStore") } },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  staticClass: "searchGroup",
                  attrs: { model: _vm.searchForm, size: "small", inline: "" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("assignTasks.table.storeName"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchForm.rtlFullName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "rtlFullName",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("assignTasks.table.storeCode"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchForm.rtlSapId },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchForm, "rtlSapId", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("assignTasks.table.contactor"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchForm.contactsNameOne },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "contactsNameOne",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.input.TTPSigningVolume"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.searchForm.tppGySign,
                          options: _vm.optConfig.tppOptions,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchForm, "tppGySign", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.PCD"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormCascader", {
                        attrs: {
                          "target-form": _vm.searchForm,
                          "key-list": [
                            "rtlRegion",
                            "rtlRegionCode",
                            "rtlCity",
                            "rtlCityCode",
                            "rtlDistrict",
                            "rtlDistrictCode",
                          ],
                          "region-props": _vm.regionProps,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.storeAddress"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchForm.rtlAddress },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "rtlAddress",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.retailerType"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.searchForm.retailerType,
                          options: _vm.optConfig.storeCategoryOptions,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "retailerType",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("doubleWeekPlan.table.rtlRtmCategory"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.searchForm.rtlRtmCategory,
                          options: _vm.optConfig.rtmOptions,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchForm,
                              "rtlRtmCategory",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SRStoreList.form.isBaiLian"),
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.searchForm.isBaiLian,
                          options: _vm.optConfig.yesnoOptionsBoolean,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchForm, "isBaiLian", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-wrapper" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "t-search-btn",
                      attrs: { size: "small", icon: "el-icon-search" },
                      on: { click: _vm.searchData },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.search")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.resetData },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reset")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.table.listLoading,
                  expression: "table.listLoading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.table.list,
                "row-key": "storeCode",
                stripe: "",
                border: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: { width: "55" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: scope.row.rtlSapId },
                            nativeOn: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.getCurrentRow(scope.row)
                              },
                            },
                            model: {
                              value: _vm.table.taskStoreChecked.rtlSapId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.table.taskStoreChecked,
                                  "rtlSapId",
                                  $$v
                                )
                              },
                              expression: "table.taskStoreChecked.rtlSapId",
                            },
                          },
                          [_vm._v(" ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlSapId",
                  label: _vm.$t("assignTasks.table.storeCode"),
                  width: "90",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlFullName",
                  label: _vm.$t("assignTasks.table.storeName"),
                  "min-width": "80",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlAddress",
                  label: _vm.$t("assignTasks.table.storeAddress"),
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "contactsNameOne",
                  label: _vm.$t("assignTasks.table.contactor"),
                  width: "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.table.total > 0,
                expression: "table.total > 0",
              },
            ],
            attrs: {
              total: _vm.table.total,
              page: _vm.table.currPage,
              limit: _vm.table.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.table, "currPage", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.table, "limit", $event)
              },
              pagination: _vm.queryList,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelSelect } }, [
                _vm._v(_vm._s(_vm.$t("common.cancel"))),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitSelect } },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }